import {
  OrdersStatsControllerHistoricOrderStatsOptionalParams,
  StatsControllerCurrentDeliveriesStatsOptionalParams,
  StatsControllerCurrentRetailOrderStatsOptionalParams,
  StatsControllerTimeInLockerOptionalParams
} from '@groundfloor-platform/mgmt-service-g-sdk';
import { useQuery } from 'react-query';
import { useApi } from '../../core/api/api.context';
import { QueryKeys } from '../../core/queries/query-keys.constants';

export function useQueryOrderStats(filters: StatsControllerCurrentRetailOrderStatsOptionalParams) {
  const api = useApi();

  return useQuery([QueryKeys.DASHBOARD, QueryKeys.ORDERS, QueryKeys.CURRENT_STATS, filters], async () => {
    return await api.statsController.currentRetailOrderStats({ includeChildProjects: true, ...filters });
  });
}

export function useQueryDeliveryStats(filters: StatsControllerCurrentDeliveriesStatsOptionalParams) {
  const api = useApi();

  return useQuery([QueryKeys.DASHBOARD, QueryKeys.DELIVERIES, QueryKeys.CURRENT_STATS, filters], async () => {
    return await api.statsController.currentDeliveriesStats({ includeChildProjects: true, ...filters });
  });
}

export function useQueryCurrentLockerUtilisation(projectID: string, refetchIntervalMs: number = 60000) {
  const api = useApi();

  return useQuery(
    [QueryKeys.DASHBOARD, projectID, QueryKeys.CURRENT_HUB_STATS],
    async () => {
      return await api.statsController.lockerUtilisation({ projectID, includeChildProjects: true });
    },
    {
      refetchInterval: refetchIntervalMs,
      keepPreviousData: true
    }
  );
}

export function useQueryHistoricStats(
  projectID: string,
  options: OrdersStatsControllerHistoricOrderStatsOptionalParams
) {
  const api = useApi();

  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  return useQuery([QueryKeys.DASHBOARD, projectID, QueryKeys.HISTORIC_ORDER_STATS, options], async () => {
    return await api.statsController.historicEvents({ projectID, includeChildProjects: true, timezone, ...options });
  });
}

export function useQueryTimeInLocker(projectID: string, options: StatsControllerTimeInLockerOptionalParams) {
  const api = useApi();

  return useQuery([QueryKeys.DASHBOARD, projectID, QueryKeys.TIME_IN_LOCKER_STATS, options], async () => {
    return await api.statsController.timeInLocker({ projectID, includeChildProjects: true, ...options });
  });
}
